import { isEmpty } from 'lodash';
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { StopListItem } from '../../utils/formatType';
import StopPoint from './components/stopPoint';
import './index.scss';
import './stopRoteMap.scss';

interface Props {
  stopList: StopListItem[];
  taskType: string;
  readonly?: boolean;
}
const StopRouteMap = (props: Props) => {
  const { stopList, taskType, readonly } = props;
  if (isEmpty(stopList)) {
    return (
      <div className='fbox vbox cbox none-roadStation'>
        <img src={require('../../assets/img/views/single/no-path.png')} />
        <span>暂无路线</span>
      </div>
    );
  }

  return (
    <div className='stopRoteMap-content'>
      <ul className='list fbox'>
        {stopList.map((item, index: number) => {
          return (
            <StopPoint
              key={index}
              {...item}
              currentIndex={index}
              taskType={taskType}
              stopList={stopList}
              readonly={readonly}
            ></StopPoint>
          );
        })}
      </ul>
    </div>
  );
};
export default React.memo(StopRouteMap);
